import { defineMessages } from 'react-intl';

export default defineMessages({
  pageHeadingText: {
    id: 'websiteCoupons.pageHeadingText',
    defaultMessage: 'Website Coupons - {cityName}',
  },
  couponPreviewLabel: {
    id: 'websiteCoupons.couponPreviewLabel',
    defaultMessage: 'Current coupons for {cityName}',
  },
  categoryLabel: {
    id: 'websiteCoupons.categoryLabel',
    defaultMessage: 'Category:',
  },
  emptyStateText: {
    id: 'websiteCoupons.emptyStateText',
    defaultMessage: 'No coupons are currently available for {cityName}.',
  },
  defaultCityName: {
    id: 'websiteCoupons.defaultCityName',
    defaultMessage: 'your city',
  },
  changeCityLabel: {
    id: 'websiteCoupons.changeCityLabel',
    defaultMessage: 'Change city',
  },
  citySearchPlaceholder: {
    id: 'websiteCoupons.citySearchPlaceholder',
    defaultMessage: 'Type a city name...',
  },
  noCityResultsText: {
    id: 'websiteCoupons.noCityResultsText',
    defaultMessage: 'No matching cities found.',
  },
  viewsText: {
    id: 'websiteCoupons.viewsText',
    defaultMessage: 'Views',
  },
  likesText: {
    id: 'websiteCoupons.likesText',
    defaultMessage: 'Likes',
  },
});